<div class="flex-cont">
  <pa-context-menu [items]="items"></pa-context-menu>
</div>